import { aludraApi } from 'api/axios'
import { mdl22Urls } from './mdl22.urls'

export const priceListByCustomerId = async customerId => {
  return aludraApi.get(mdl22Urls.priceListUrl + '?CustomerId=' + customerId)
}

export const productPriceInventory = async payload => {
  return aludraApi.post(mdl22Urls.productsPricesURL, payload)
}

export const finalPrice = async payload => {
  return aludraApi.post(mdl22Urls.finalPriceUrl, payload)
}

export const fullfilmentPlan = async => {
  return aludraApi.get(mdl22Urls.fullfillmentPlanUrl)
}

export const allQuickLists = async payload => {
  return aludraApi.post(mdl22Urls.searchListURL, payload)
}

export const createQuickList = async payload => {
  return aludraApi.post(mdl22Urls.createNewListURL, payload)
}

/**
 * Service that allows searching for products within the tinting options.
 * The search for products within tinting options is different from the general product search.
 *
 * @param {Object} payload - Data sent in the request.
 * @param {string} [payload.code] - ProductId or SKU of the product. If not provided, the search will be done without this filter.
 * @param {string} payload.searchText - Text to search within the tinting options.
 * @param {number} payload.pageSize - Number of records per page.
 * @param {number} payload.pageNumber - The page number to retrieve.
 * @returns {Promise<Object>} - Returns the backend response with the products matching the filters.
 */

export const linkedProductVariants = async (payload = {}) => {
  const defaultPagination = {
    PageNumber: 1,
    PageSize: 10,
  }

  const requestBody = {
    ...defaultPagination,
    ...payload,
  }

  const { data } = await aludraApi.post(
    mdl22Urls.fetchLinkedProductVariants,
    requestBody
  )
  return data
}
